module.exports = __webpack_public_path__ + "img/dexguru.7941d4d0.jpeg";